export default "__VITE_ASSET__BDJT1DNK__"